import { observable, configure, action, computed } from 'mobx';
import StoreModel from './storeModel';

configure({ enforceActions: 'always' });

class MailaddressStore extends StoreModel {
    constructor() {
        super('mailaddress', {
            namePlural: 'mailaddresses',
            sort: '-updatedDate',
            api: {
                search: {
                    url: '/api/mailaddress/',
                    params: {},
                },
                load: {
                    url: '/api/mailaddress/',
                    params: {},
                },
                save: {
                    url: '/api/mailaddress/',
                    params: {},
                },
                delete: {
                    url: '/api/mailaddress/',
                    params: {},
                },
            },
            queryFilter: {},
        });
    }

    @observable mailaddress = {};

    @observable mailaddresses = [];
}

const store = new MailaddressStore();
export default store;



// WEBPACK FOOTER //
// ./stores/mailaddress.js